export default {
  'app.pwa.offline': 'Jesteś teraz offline',
  'app.pwa.serviceworker.updated': 'Dostępna jest nowa zawartość',
  'app.pwa.serviceworker.updated.hint':
    'Proszę nacisnąć przycisk „Odśwież”, aby ponownie załadować bieżącą stronę',
  'app.pwa.serviceworker.updated.ok': 'Odśwież',
};
